import React from 'react'
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY, LogInUserID, MMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import GreyBoxForReports from './GreyBoxForReports';

export default function MassTickets({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    async function GetTicketData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            setalerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
        }, 2000);

        setTimeout(() => {
            setalerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/reports/ticket-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&userId=${LogInUserID}&flag=${downloadall}`);
        }, 0);
    }
    return (
        <GreyBoxForReports icon="faTicket" name={"Bulk Tickets Report Download"} onclickfunc={GetTicketData} />
    )
}
